import React, { useState } from "react";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { loginWithGoogle } from "../api/hrmApi";

const googleClientId = process.env.REACT_APP_PRODUCTION_GOOGLE_OATH_CLIENT_ID;

const HrmLogin = ({ onLogin }) => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      setError("");
      setLoading(true);
      const session = await loginWithGoogle(credentialResponse.credential);
      onLogin(session);
    } catch (loginError) {
      setError(loginError.message || "Google sign-in failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="new-hrm-login">
      <section className="new-hrm-login__panel">
        <img
          className="new-hrm-login__logo"
          src="/assets/antrazal-brand.svg"
          alt="Antrazal"
        />
        <h1>People workspace</h1>
        <p>Sign in with your Antrazal account.</p>

        {googleClientId ? (
          <GoogleOAuthProvider clientId={googleClientId}>
            <div className="new-hrm-google-login-wrap">
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => setError("Google sign-in failed. Please try again.")}
                useOneTap={false}
              />
            </div>
            {loading && <p className="new-hrm-login__meta">Signing in...</p>}
          </GoogleOAuthProvider>
        ) : (
          <p className="new-hrm-login__error">Google sign-in is not configured.</p>
        )}

        {error && <p className="new-hrm-login__error">{error}</p>}
      </section>
    </main>
  );
};

export default HrmLogin;
